/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

/**
 * False on the first web render so SSR HTML matches the client, then true
 * after mount. Native starts hydrated (no SSR mismatch).
 */
export const useIsClientHydrated = (): boolean => {
  const [isClientHydrated, setIsClientHydrated] = useState(
    Platform.OS !== 'web',
  );

  useEffect(() => {
    if (Platform.OS === 'web') {
      setIsClientHydrated(true);
    }
  }, []);

  return isClientHydrated;
};
